import { DEFAULT_WIDTH_COL } from "@lhd/features/Apps/AppForm/constants";
import { useEffect, useRef, useState } from "react";
interface IProps {
  onUpdateWidth: (width: number) => void;
}
const useReside = (props: IProps) => {
  const { onUpdateWidth } = props;
  const resideBarContainerRef = useRef<HTMLDivElement>(null);
  const itemContainerRef = useRef<HTMLDivElement>(null);
  const xStartRef = useRef<number>(0);

  const [isResiding, setIsResiding] = useState(false);
  useEffect(() => {
    const abortController = new AbortController();
    if (resideBarContainerRef.current) {
      resideBarContainerRef.current.onmousedown = (e) => {
        xStartRef.current = e.x;
        e.stopPropagation();
        setIsResiding(true);
      };
    }
    if (
      resideBarContainerRef.current &&
      isResiding &&
      itemContainerRef.current
    ) {
      const currentWidth = itemContainerRef.current.offsetWidth;
      window.addEventListener(
        "mousemove",
        (e) => {
          if (!itemContainerRef.current) return;
          const widthAdded = e.x - xStartRef.current;
          const totalWidth = Math.max(
            currentWidth + widthAdded,
            DEFAULT_WIDTH_COL,
          );
          itemContainerRef.current.style.width = totalWidth + "px";
        },
        { signal: abortController.signal },
      );

      window.addEventListener(
        "mouseup",
        (e) => {
          if (itemContainerRef.current) {
            const currentWidth = itemContainerRef.current.offsetWidth;
            onUpdateWidth(currentWidth);
          }
          setIsResiding(false);
        },
        { signal: abortController.signal, capture: true },
      );
    }

    return () => abortController.abort();
  }, [resideBarContainerRef.current, isResiding, itemContainerRef.current]);
  return {
    resideBarContainerRef,
    itemContainerRef,
    setIsResiding,
    isResiding,
  };
};

export default useReside;
